import React from "react";
import { useDispatch } from "react-redux";
import Measure from "react-measure";
import {
	DataGrid,
	ProgressIndicator
} from "rhombus-react";
import { Submission } from "reducers/QASubmission";

import { useGridScrollUtils } from "utils/DataGrid";
import { MIN_GRID_HEIGHT, DEFAULT_ROW_HEIGHT } from "utils/constants";


export default function ApprovalGrid({ items, sort, isLoading, columns }){
	const dataGridRef = useGridScrollUtils([items]);
	const dispatch = useDispatch();

	const [sortColumn, sortDirection] = sort.split(":");

	function getLibraryRow(rowID){
		return items[rowID];
	}

	const dataGridProps = {
		columns,
		rowGetter:  getLibraryRow,
		rowsCount:  items.length,
		rowHeight:  DEFAULT_ROW_HEIGHT,

		sortColumn,
		sortDirection,
		onGridSort: (col, dir) => dispatch(Submission.setSort(col, dir)),
		enableCellAutoFocus: false, /*
			This is a ReactDataGrid setting that defaults to `true`, which seems to make it fight
			with anything else trying to utilize regular `tabindex` control flow, like blade forms.
		*/
	};

	return (
		<Measure>
			{(obj) => {
				let gridHeight = obj?.contentRect?.entry?.height || MIN_GRID_HEIGHT;
				return (
					<div className="measure-component" ref={obj.measureRef}>
						<ProgressIndicator isLoading={isLoading} />
						<div ref={dataGridRef}>
							<DataGrid {...dataGridProps} minHeight={gridHeight} />
						</div>
					</div>
				);
			}}
		</Measure>
	);
}

ApprovalGrid.displayName = "ApprovalGrid";
ApprovalGrid.defaultProps = {
	items:[],
	sort:"",
	isLoading:true,
};
